import React from 'react'
import RecordingGroupCategory from '@App/enum/recording-group-category'
import { PaginationBody, PaginationInfo } from '@Entities/pagination'
import { INumTitles } from '@App/helpers/pagination/get-num-titles'
import RecordingGroupTab from './recording-group-tab'
import { Tab } from '@Components/TabsWrapperComponent'

export interface RecordingGroupInfoMap {
    [RecordingGroupCategory.Rejected]?: {
        totalCount: number
        numTitles: INumTitles | undefined
        paginationData: PaginationInfo | undefined
    }
    [RecordingGroupCategory.Pending]?: {
        totalCount: number
        numTitles: INumTitles | undefined
        paginationData: PaginationInfo | undefined
    }
    [RecordingGroupCategory.Accepted]?: {
        totalCount: number
        numTitles: INumTitles | undefined
        paginationData: PaginationInfo | undefined
    }
}

interface RecordingGroupTabsProps {
    recordingGroupInfo: RecordingGroupInfoMap
    resultsLimit: number
    onPageChange: (status: RecordingGroupCategory, pagination: PaginationBody) => void
    onLimitChange: (status: RecordingGroupCategory, newLimit: number) => void
}

export const createRecordingGroupTabs = ({
    recordingGroupInfo,
    resultsLimit,
    onPageChange,
    onLimitChange,
}: RecordingGroupTabsProps): Tab[] => {
    const statuses = [RecordingGroupCategory.Rejected, RecordingGroupCategory.Pending, RecordingGroupCategory.Accepted]

    return statuses.map((status) => {
        const info = recordingGroupInfo[status]
        const totalCount = info?.totalCount ?? 0

        return {
            tabDisplayName: `${status.charAt(0).toUpperCase() + status.slice(1)} (${totalCount})`,
            tabName: status.toLowerCase(),
            tabComponent: (
                <RecordingGroupTab
                    status={status}
                    totalCount={totalCount}
                    numTitles={info?.numTitles}
                    paginationData={info?.paginationData}
                    onPageChange={(p) => onPageChange(status, p)}
                    onLimitChange={(newLimit) => onLimitChange(status, newLimit)}
                    resultsLimit={resultsLimit}
                />
            ),
        }
    })
}
